// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const PathCartToggleWrapper = styled.button`
  border-radius: .125rem;
  overflow: hidden;

  > .fa-bars {
    padding: .125rem;
  }
`
